export interface TrustindexReview {
  id: string;
  name: string;
  date: string;
  rating: number;
  avatar: string;
  text: string;
  replyDate?: string;
  replyText?: string;
  source: 'Google';
  verified: boolean;
}

export interface TrustindexSummary {
  companyName: string;
  domain: string;
  profileUrl: string;
  ratingScore: number;
  maxScore: number;
  ratingLabel: 'Excellent';
  totalReviews: number;
  fiveStarPercentage: number;
  replyRatePercentage: number;
  replyTimeLabel: string;
  topRatedCertificate: boolean;
  claimedProfile: boolean;
  location: string;
  category: string;
  breakdown: {
    stars: number;
    count: number;
    percentage: number;
  }[];
}

export const TRUSTINDEX_SUMMARY: TrustindexSummary = {
  companyName: 'XwebA',
  domain: 'xweba.com',
  profileUrl: 'https://www.trustindex.io/reviews/xweba.com',
  ratingScore: 4.9,
  maxScore: 5.0,
  ratingLabel: 'Excellent',
  totalReviews: 24,
  fiveStarPercentage: 92,
  replyRatePercentage: 67,
  replyTimeLabel: 'Replies to 67% of reviews within 1 day',
  topRatedCertificate: true,
  claimedProfile: true,
  location: 'Nextgen Mall, Nairobi 00100, Kenya',
  category: 'AI Web Engineering & Digital Growth Agency',
  breakdown: [
    { stars: 5, count: 22, percentage: 92 },
    { stars: 4, count: 2, percentage: 8 },
    { stars: 3, count: 0, percentage: 0 },
    { stars: 2, count: 0, percentage: 0 },
    { stars: 1, count: 0, percentage: 0 },
  ],
};

export const TRUSTINDEX_REVIEWS: TrustindexReview[] = [
  {
    id: '295474932',
    name: 'Jawahir Y',
    date: '2026-10-13',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjUGqG5JP2sx-Atqze7WqYF7uOegS_PvJZJlnzzTc4DnnLbiEukT=s120-c-rp-mo-br100',
    text: 'I’m so grateful for the work done on my business website. Professional, honest, and incredibly gifted. Every detail was handled with care, and the final result truly exceeded my expectations. Highly recommend working with John!',
    source: 'Google',
    verified: true,
  },
  {
    id: '256625367',
    name: 'Neema Assisted Living Homes LLC',
    date: '2026-06-10',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjV6YkCY0FDrNG9J319Ho_oNh0Rlk0C15RpQ7ADFf3-fkAG5Zdc=s120-c-rp-mo-br100',
    text: 'Best web designer, I am glad I was connected to your company. I love love your work. Thank you for Making us a great website!',
    replyDate: '2026-06-05',
    replyText:
      'Thank You Neema for trusting us. we are privillaged to work for you now and the coming days ahead.',
    source: 'Google',
    verified: true,
  },
  {
    id: '256625366',
    name: 'John Njoroge',
    date: '2026-06-04',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjXWqv1jrR21JtxkRXOLqxaxo4xm3eXB3cBzS7lUdpU-1ow7DC_hXQ=s120-c-rp-mo-br100',
    text: 'Thanks a million for your an excellent work on our website, brochures and business cards. It has really given a boost to our business and l can confidently recommend you to any business person out there.',
    replyDate: '2026-06-05',
    replyText: 'It was all our pleasure sir.',
    source: 'Google',
    verified: true,
  },
  {
    id: '220929431',
    name: 'Elizabeth Johnstone',
    date: '2023-02-27',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjVXsfo5njIg7TA414PRrAgFl1NImzdQXmG1wPZnssRQegXFf83MrA=s120-c-rp-mo-br100',
    text: 'even in a million years to come, i will still choose you. best service ever',
    source: 'Google',
    verified: true,
  },
  {
    id: '245932993',
    name: 'The Mogadishu Times',
    date: '2022-12-08',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a/ACg8ocLkFzP8drh7r6mtaO69OveqN5pGXGSajA-u63-pz6tb_BlQEA=s120-c-rp-mo-br100',
    text: 'I’m very happy about the service I received. John is very professional and he knows what he is doing. I would recommend john. Liban',
    source: 'Google',
    verified: true,
  },
  {
    id: '220929435',
    name: 'Abdirahman Ali',
    date: '2022-12-07',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a/ACg8ocKO_vwru8EuyTzaFKRMFC2xrl7qZAEqER1XykSvbSiwrjQonw=s120-c-rp-mo-br100',
    text: 'Bestoplay is home for digital and technology hub. Thanks for making my website and all graphics designs. Amazing. I call Bestoplay my Brand Image Director',
    replyDate: '2022-12-07',
    replyText: 'Thank you Sir, it is an honor working for your organization',
    source: 'Google',
    verified: true,
  },
  {
    id: '220929432',
    name: 'Japheth Kimanthi',
    date: '2023-02-01',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjVJSnQlHbkitk6oTpfNkU3tPk1_I2dT7l5dN-q-giv5If0ye6Qw8g=s120-c-rp-mo-ba12-br100',
    text: 'one of the best graphic design and marketing company i have ever seen.i would recommend this company to anyone and any company.',
    source: 'Google',
    verified: true,
  },
  {
    id: '220929437',
    name: 'Leonard Oduor',
    date: '2021-08-04',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a/ACg8ocKc4zC7JusUQlIJww1bV9oS1rvoKpL9a60LP_BRlDSiaNX3XNM=s120-c-rp-mo-br100',
    text: 'I’m very happy that I made the right decision. I have peace of mind with my online business platform knowing that BestoPlay has got me covered.',
    replyDate: '2021-08-04',
    replyText: 'Thank you Sir for your kind words.',
    source: 'Google',
    verified: true,
  },
  {
    id: '220929439',
    name: 'Felix Robert',
    date: '2021-08-01',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjXHiXXeKKDpCLuAdajM-5bG6tX6CQDXZZrTvDJ-m-w8o1crah78=s120-c-rp-mo-br100',
    text: 'one of the best graphic design and marketing company i have ever seen.i would recommend this company to anyone and any company.Kudos',
    replyDate: '2021-08-04',
    replyText: 'Thank you Felix for your kind words and business too',
    source: 'Google',
    verified: true,
  },
  {
    id: '220929442',
    name: 'Lugard Abila',
    date: '2021-08-01',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjWZNkIF9oZLtOkqw8w320nqWolze-pe0ZT-O4WkAlPTDAIeqIKCAQ=s120-c-rp-mo-br100',
    text: 'BestoPlay is your partner in branding. they are proffessional and there end product is always execellent.',
    replyDate: '2021-08-01',
    replyText: 'Thank lugard for your business and good review',
    source: 'Google',
    verified: true,
  },
  {
    id: '220929430',
    name: 'Judina Bertha',
    date: '2023-02-27',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjXqMcEOAbsh4wHrzf2vCRnD2Pty4MoJVrggltkdKRuLeKBARS4=s120-c-rp-mo-br100',
    text: 'Well done Katana for the commendable work you are doing.',
    source: 'Google',
    verified: true,
  },
  {
    id: '220929436',
    name: 'amoswambua91',
    date: '2022-11-17',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a/ACg8ocJzOWYRiDD32bFdasduPrRcaPF2miEOxCY21JFD1CYEynaPew=s120-c-rp-mo-br100',
    text: 'Best in services (web design and designs)',
    source: 'Google',
    verified: true,
  },
  {
    id: '220929441',
    name: 'Bramwel Rotich',
    date: '2021-08-01',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjWSkTbYKOehMr_Q82EpevnCa8N7Mip5pgW2eCPRoh5BI_6q1419BQ=s120-c-rp-mo-br100',
    text: 'I highly recommend',
    replyDate: '2021-08-01',
    replyText: 'Thank you Bramwel for your business',
    source: 'Google',
    verified: true,
  },
  {
    id: '220929429',
    name: 'Star edge internet services',
    date: '2023-02-27',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjXFAv6Rdh7Ma7lASxGmrU1wHc7r0VbBCsYQmoO8TlneLmGOU1DXDg=s120-c-rp-mo-ba12-br100',
    text: 'Good',
    source: 'Google',
    verified: true,
  },
  {
    id: '220929438',
    name: 'LILAM PRODUCTIONS',
    date: '2021-08-02',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a/ACg8ocIykxCb6AjU3NxKWJGi57RphR_tq6cQiUnSz2pXNSYiJ6L8lw=s120-c-rp-mo-br100',
    text: '',
    replyDate: '2021-08-04',
    replyText: 'Thank you lilam productions for the 5stars',
    source: 'Google',
    verified: true,
  },
  {
    id: '243646398',
    name: 'Boni Manyala',
    date: '2021-08-01',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjUwcz31ezZ5ZCQ_J-UlJ3IhOt0-NY1DkLJI4h-eC_FZeWERc_AyiA=s120-c-rp-mo-br100',
    text: '',
    replyDate: '2021-08-04',
    replyText: 'Thank you for the Stars✨',
    source: 'Google',
    verified: true,
  },
  {
    id: '220929443',
    name: 'Its Musyoki',
    date: '2021-08-01',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjXDTjEa6th4yj1GrWyPKKvxkJMjMFEo6nICGk7LhyIEVW8EgNhY=s120-c-rp-mo-br100',
    text: '',
    replyDate: '2021-08-04',
    replyText: 'Ahsante sana bro',
    source: 'Google',
    verified: true,
  },
  {
    id: '225706441',
    name: 'Tevin Kitheka',
    date: '2021-08-01',
    rating: 5,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjV9qxrpyFjugC9Ynf8km5Gyr5-BQ2ibaP7jCa7kY0We748eGX33=s120-c-rp-mo-br100',
    text: '',
    replyDate: '2021-08-04',
    replyText: 'Thank you sir',
    source: 'Google',
    verified: true,
  },
  {
    id: '220929434',
    name: 'Mbeyu Thoya',
    date: '2022-12-07',
    rating: 4,
    avatar:
      'https://lh3.googleusercontent.com/a-/ALV-UjUOVNMN2GNyVdShoN0A0IIzK6vDM0rCws5mn25HWZCfmtOi4-xXgg=s120-c-rp-mo-br100',
    text: '',
    source: 'Google',
    verified: true,
  },
  {
    id: '245932994',
    name: 'Joseph Kiguta',
    date: '2021-08-01',
    rating: 4,
    avatar:
      'https://lh3.googleusercontent.com/a/ACg8ocI-9Que4Q4gQWO2iJ18-nSonmCAu8KaHDUb2lE5g-Rq5up3lg=s120-c-rp-mo-br100',
    text: '',
    replyDate: '2021-08-04',
    replyText: 'Thank you Sir for the stars',
    source: 'Google',
    verified: true,
  },
];
